import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useSelector } from '@bonanza-social/toolkit/state';
import {
  Box,
  Text,
  Breakpoint,
  PressableIcon,
  useBreakpoint,
} from '@bonanza-social/moonlight';
import { selectPrizeWallCampaignName } from '../../state/prizeWallCampaign/prizeWallCampaign.slice';
import { PrizeWallCampaignHeaderProps } from './PrizeWallCampaignHeader.types';
import PrizeWallHeaderBase from '../common/PrizeWallHeaderBase/PrizeWallHeaderBase';
import PrizeWallTokensInfo from '../PrizeWallTokensInfo/PrizeWallTokensInfo';

function PrizeWallCampaignHeader(props: PrizeWallCampaignHeaderProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const campaignName = useSelector(selectPrizeWallCampaignName);
  const breakpoint = useBreakpoint();

  const onInfo = useCallback(() => {
    navigation.navigate('PrizeWallCampaign', { screen: 'PrizeWallInfoScreen' });
  }, [navigation]);

  return (
    <PrizeWallHeaderBase {...props}>
      <Box flexDirection="row" gap="space-100" centerContent>
        <Text
          variant="body-m"
          {...(breakpoint === Breakpoint.MOBILE
            ? { color: 'darkSurfacePrimary' }
            : { gradient: 'darkSurfaceAccent' })}
        >
          {campaignName}
        </Text>
        <PressableIcon
          name="info"
          iconWidth="space-500"
          iconHeight="space-500"
          onPress={onInfo}
          {...(breakpoint === Breakpoint.MOBILE
            ? { color: 'iconSecondary' }
            : { gradient: 'accentBackground' })}
        />
      </Box>
      <PrizeWallTokensInfo />
    </PrizeWallHeaderBase>
  );
}

export default memo(PrizeWallCampaignHeader);
